var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagNewIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.765 14.2354V16.2646C18.765 16.6708 19.0944 17 19.5005 17C19.9065 16.9998 20.235 16.6706 20.235 16.2646V14.2354H22.2655C22.6715 14.2352 23 13.906 23 13.5C23 13.094 22.6715 12.7648 22.2655 12.7646H20.235V10.7354C20.235 10.3294 19.9065 10.0002 19.5005 10C19.0944 10 18.765 10.3292 18.765 10.7354V12.7646H16.7355C16.3294 12.7646 16 13.0938 16 13.5C16 13.9062 16.3294 14.2354 16.7355 14.2354H18.765Z",
    fill: "currentFill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7248 7.5V3.2335C22.7248 1.9171 21.6577 0.850098 20.3414 0.850098H8.22031C7.58831 0.850098 6.98191 1.1012 6.53501 1.5482L1.76841 6.3149C0.837613 7.2455 0.837613 8.7547 1.76841 9.6854L6.53501 14.452C6.98191 14.899 7.58831 15.1501 8.22031 15.1501H13",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56208 5.9653C9.60978 5.9653 10.4592 6.8072 10.4592 7.8624C10.4592 8.9101 9.61728 9.7595 8.56208 9.7595C7.51428 9.7595 6.66498 8.9176 6.66498 7.8624C6.66498 6.8146 7.50688 5.9653 8.56208 5.9653Z",
    fill: "currentFill",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagNewIcon);
export default __webpack_public_path__ + "static/media/tagNewIcon.a9f4990fc96acf325665cc709396a5d3.svg";
export { ForwardRef as ReactComponent };